<template>
  <div class="app-container">
    <el-form
      :model="noteForm"
      ref="noteForm"
      :rules="rules"
      label-width="150px"
      class="demo-ruleForm"
      size="medium"
    >
      <el-form-item label="安卓App下载链接" prop="down_url">
        <!-- :on-success="handleAvatarSuccess" -->
        <!-- name="file[]"
          :data="{type:'image'}"
          ,'imageOss'
          ossUpload: this.$store.state.ossUpload, -->
        <el-upload
          v-if="cztype != 'see'"
          accept=".apk"
          :on-success="handleAvatarSuccess"
          ref="upload"
          name="file[]"
          :data="{ type: 'file' }"
          :headers="{ token: token }"
          :action="ossUpload"
          class="upload-demo"
          :multiple="true"
          :limit="1"
          v-loading.fullscreen.lock="loading"
          element-loading-text="上传中..."
          :before-upload="beforeUploadFn"
        >
          <el-button size="small" type="primary"
            >点击上传</el-button
          > </el-upload
        ><!-- 已修改 -->
        <el-input
          disabled
          v-model="noteForm.down_url"
          placeholder="请输入app下载链接"
        ></el-input>
      </el-form-item>
      <el-form-item label="安卓App最新版本号" prop="version">
        <el-input
          v-model="noteForm.version"
          :disabled="cztype == 'see'"
          placeholder="请输入App最新版本号"
        ></el-input>
      </el-form-item>
      <el-form-item label="安卓App更新方式" prop="update_type">
        <el-select
          filterable
          :disabled="cztype == 'see'"
          v-model="noteForm.update_type"
          placeholder="请选择"
        >
          <el-option label="热更新" value="wgt"> </el-option>
          <el-option label="覆盖安装" value="upgrade"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="苹果IOS下载链接" prop="down_url">
        <el-input
          :disabled="cztype == 'see'"
          v-model="noteForm.ios_url"
          placeholder="请输入苹果IOS下载链接"
        ></el-input>
      </el-form-item>
      <el-form-item label="苹果IOS最新版本号" prop="version">
        <el-input
          v-model="noteForm.version_ios"
          :disabled="cztype == 'see'"
          placeholder="请输入苹果IOS最新版本号"
        ></el-input>
      </el-form-item>
      <el-form-item v-if="cztype == 'edit'">
        <el-button
          type="primary"
          @click="edit()"
          v-if="roles.includes('/conf/set_app_update')"
        >
          立即修改
        </el-button>
        <el-button type="info" @click="getInfo()"> 取消 </el-button>
      </el-form-item>
      <el-form-item v-else>
        <el-button type="success" @click="cztype = 'edit'"> 修改 </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getAppUp, setAppUp, ossUpload } from "@/api/conf";
import { getToken } from "@/utils/auth";
import { mapGetters } from "vuex";
export default {
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger",
      };
      return statusMap[status];
    },
  },
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      token: getToken(),
      ossUpload: this.$store.state.ossUpload,
      uploadUrl: this.$store.state.baseURL,
      noteForm: {},
      cztype: "see",
      rules: {
        down_url: [
          { required: true, message: "请输入app下载链接", trigger: "blur" },
        ],
        version: [
          { required: true, message: "请输入当前版本号", trigger: "blur" },
        ],
        update_type: [{ required: true, message: "请选择更新方式" }],
      },
      fileItem: {}, // 正在上传的图片
      loading: false,
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    beforeUploadFn() {
      this.loading = true;
    },
    // 上传
    handleAvatarSuccess(res, file) {
      this.loading = false;
      if (res.code === 200) {
        // if (this.ruleForm.picture) {
        //   this.delImg(this.ruleForm.picture);
        // }
        this.noteForm.down_url = this.imageOss + res.data.url;
      }
      this.$refs.upload.clearFiles();
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },
    // 修改
    edit() {
      var that = this;
      setAppUp(this.noteForm).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: res.msg,
            type: "success",
          });
          that.getInfo();
        }
      });
    },
    // LTAI5tBLribUTNddK3dcHEmf
    getInfo() {
      getAppUp().then((res) => {
        this.noteForm = {
          down_url: res.data.down_url,
          update_type: res.data.update_type,
          version: res.data.version,
          ios_url: res.data.ios_url,
          version_ios: res.data.version_ios,
        };
        this.cztype = "see";
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.app-container {
  padding: 60px;
}
::v-deep .el-upload-list {
  display: none;
}
</style>
